@for (toast of toastService.toasts; track toast) {
  <ngb-toast [class]="toast.classname" [autohide]="true"
    [delay]="toast.delay || 3000" (hidden)="toastService.remove(toast)" >
    @if (isTemplate(toast)) {
      <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    } @else {
      {{ toast.textOrTpl }}
    }
  </ngb-toast>
}